export abstract class AssRefMatsEvent {}

export class AssRefMatsLoad extends AssRefMatsEvent {}
